import { UseMutationOptions, useMutation } from '@tanstack/react-query'
import { PostLLMFeedbackParams } from '~/interfaces/llm'
import { postLLMFeedback } from '~/services/llm'

export const usePostLLMFeedback = (
  config?: UseMutationOptions<PostLLMFeedbackParams, Error, PostLLMFeedbackParams>
) => {
  return useMutation(postLLMFeedback, {
    ...config,
    retry: 3
  })
}
